export { DtvFlash as default } from "./dtv-flash";
export type { DtvFlashProps } from "./dtv-flash";
